import { Default, Detail, List,  Create } from "./views";



const Module = {
    name: "notificationmodels",
    defaultRoutePath: "/notifications/model",
    menuItemScope: "notifications",
    menuItemName: "notificationmodels",

    routes: [
        {
            path: "/notifications/model",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],
    
}

export default Module;
